export const STATISTICS_THEME = {
  surface: 'rgba(247, 248, 249, 0.84)',
  surfaceAlt: 'rgba(255, 255, 255, 0.82)',
  controlSurface: 'rgba(255, 255, 255, 0.86)',
  tooltipSurface: 'rgba(255, 255, 255, 0.92)',
  border: 'rgba(15, 23, 42, 0.08)',
  borderStrong: 'rgba(15, 23, 42, 0.14)',
  textPrimary: '#111827',
  textMuted: '#6b7280',
  textHint: '#94a3b8',
  gridLine: 'rgba(15, 23, 42, 0.06)',
  axisLine: 'rgba(15, 23, 42, 0.12)',
  actualSpeed: '#2563eb',
  expectedSpeed: '#0f172a',
  contractSpeed: '#7c3aed',
  efficiency: '#f59e0b'
};

export const OVERVIEW_DATASET_KEY = '__overview__';
export const OVERVIEW_DATASET = {
  key: OVERVIEW_DATASET_KEY,
  label: 'Overview',
  areaIdentifier: OVERVIEW_DATASET_KEY,
  color: '#2563eb'
};

export const OVERVIEW_AVERAGE_KEY = 'averageEfficiency';
export const SIGNAL_OVERLAP_DATASET_KEY = '__signal_overlap__';
export const SIGNAL_OVERLAP_DATASET = {
  key: SIGNAL_OVERLAP_DATASET_KEY,
  label: 'Signal Overlap',
  areaIdentifier: SIGNAL_OVERLAP_DATASET_KEY,
  color: '#7c3aed'
};
export const SIGNAL_OVERLAP_FIELDS = [
  { key: 'materialBefore', label: 'Material Before', color: '#2563eb' },
  { key: 'machineAvailable', label: 'Machine Available', color: '#22c55e' },
  { key: 'allowanceForward', label: 'Allowance Forward', color: '#f59e0b' },
  { key: 'pcDataOk', label: 'PC Data OK', color: '#7c3aed' }
];
export const SIGNAL_MAIN_FIELD = { key: 'aggregatedMainSignals', label: 'All Main Signals', color: '#0f172a' };
export const EMPTY_STATISTICS_DATASETS = [];
export const DEFAULT_LIVE_RANGE_HOURS = 1 / 6;
export const RANGE_PRESET_HOURS = [1, 6, 12, 24];

export const EXCLUDE_TIMES_CURSOR = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M6 6L18 18M18 6L6 18' stroke='%23dc2626' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E") 12 12, crosshair`;

export const RESTORE_TIMES_CURSOR = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M5 12L10 17L20 6' fill='none' stroke='%2316a34a' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") 12 12, pointer`;

export const DIMENSION_SWITCH_COLORS = ['#dbeafe', '#fef3c7'];

export const PRODUCTION_STOP_COLOR = '#8b5cf6';
